import React from 'react';
import ReactSVG from 'react-svg';

import bubble from '../img/bubble.svg';

class NewsletterHeader extends React.Component {
  constructor(props) {
    super(props);

    const { daysToNextUpdate } = this.props;
    this.modifierClass = this.getModifierClass(daysToNextUpdate);
  }

  getModifierClass(daysToNextUpdate) {
    // in case something strange happens... display the default one
    if (daysToNextUpdate < 0) {
      return 'c-jumbotron--default';
    }

    if (daysToNextUpdate > 7) {
      return 'c-jumbotron--default';
    } else if (daysToNextUpdate > 3) {
      return 'c-jumbotron--warning';
    } else {
      return 'c-jumbotron--danger';
    }
  }

  render() {
    const { title, subtitle, message } = this.props;

    return (
      <div
        className={`c-jumbotron u-padding-vertical-huge ${this.modifierClass}`}
      >
        <div className="o-wrapper o-wrapper--large">
          <ReactSVG
            src={bubble}
            svgClassName="c-jumbotron__bg-element c-jumbotron__bg-element--1"
          />
          <ReactSVG
            src={bubble}
            svgClassName="c-jumbotron__bg-element c-jumbotron__bg-element--2"
          />
          <div className="o-layout o-layout--large">
            <div className="o-layout__item u-2/3@mini-geri u-1/1">
              {title && <h1>{title}</h1>}
              {subtitle && <p className="c-jumbotron__text">{subtitle}</p>}
              {message && <p className="c-jumbotron__text">{message}</p>}

              {/* TODO: Figure out a call-to-action which makes more sense */}
              {/* <div className="u-margin-top-micro">
                <Link to="/updates/last" className="c-jumbotron__link">
                  Manage the updates about you
                </Link>
              </div> */}
            </div>

            {/* TODO: Figure out how to utilize this one */}
            {/* <div className="o-layout__item u-1/3@mini-geri u-1/1">
              <div className="c-dropdown u-margin-top-huge">
                <div className="c-dropdown__title u-margin-bottom-micro">
                  Updates by month
                </div>
                <select className="c-dropdown__menu">
                  <option value="first">January - March</option>
                  <option value="second">April - June</option>
                  <option value="third">July - September</option>
                  <option value="fourth">October - December</option>
                </select>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    );
  }
}

export default NewsletterHeader;



// WEBPACK FOOTER //
// ./src/common/NewsletterHeader.js